module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0